"use client";

import { jsx } from "react/jsx-runtime";
import { Children, isValidElement, useMemo } from "react";
import { NAVIGATOR_CONFIG } from "../../headless/children";
import { StackHeaderComponent, appendStackHeaderPropsToOptions } from "./StackHeaderComponent";
import { StackToolbarComponent, appendStackToolbarPropsToOptions } from "./StackToolbar";
import { Screen } from "../../views/Screen";

function StackScreen(param) {
	var { children, options, ...rest } = param;
	var updatedOptions = useMemo(function() {
		return appendScreenStackPropsToOptions(options !== null && options !== void 0 ? options : {}, { children });
	}, [options, children]);
	return /* @__PURE__ */ jsx(Screen, {
		...rest,
		options: updatedOptions
	});
}
Object.assign(StackScreen, { [NAVIGATOR_CONFIG]: true });
var NATIVE_PRESENTATIONS = [
	"card",
	"modal",
	"transparentModal",
	"containedModal",
	"containedTransparentModal",
	"fullScreenModal",
	"formSheet",
	"pageSheet"
];
function validateStackPresentation(options) {
	if (typeof options === "function") return function() {
		for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
		return validateStackPresentation(options(...args));
	};
	if (!options.presentation) return options;
	if (options.presentation === "sheet") return {
		...options,
		presentation: "formSheet"
	};
	return NATIVE_PRESENTATIONS.includes(options.presentation) ? options : {
		...options,
		presentation: "modal"
	};
}
function appendScreenStackPropsToOptions(options, props) {
	var updatedOptions = {
		...options,
		...props.options
	};
	updatedOptions = validateStackPresentation(updatedOptions);
	function appendChildOptions(child, options2) {
		if (child.type === StackHeaderComponent) return appendStackHeaderPropsToOptions(options2, child.props);
		else if (child.type === StackToolbarComponent) return appendStackToolbarPropsToOptions(options2, child.props);
		else {
			var _child_type_name;
			console.warn(`Warning: Unknown child element passed to Stack.Screen: ${(_child_type_name = child.type.name) !== null && _child_type_name !== void 0 ? _child_type_name : child.type}`);
		}
		return options2;
	}
	Children.forEach(props.children, function(child) {
		if (/* @__PURE__ */ isValidElement(child)) updatedOptions = appendChildOptions(child, updatedOptions);
	});
	return updatedOptions;
}

export { StackScreen, appendScreenStackPropsToOptions, validateStackPresentation };